import React from "react";
import Flex from "../Generic/Flex";
import AppSwitch from "../Generic/AppSwitch/AppSwitch";
import { CaregiverStaffingPreferenceTypes } from "../../messages";
import "./MystaffingPreferences.scss";

interface StaffingPreferenceSwitchProps {
  label: string;
  type: CaregiverStaffingPreferenceTypes;
  value: boolean;
  onChange: (preference: CaregiverStaffingPreferenceTypes, value: boolean) => void;
}

const StaffingPreferenceSwitch = (props: StaffingPreferenceSwitchProps) => {
  return (
    <Flex direction="row" gap={20} alignItems="center" justifyContent="space-between">
      <div> {props.label} </div>
      <div className="MyStaffingPreferences_SwitchContainer">
        <AppSwitch
          checked={props.value}
          onChange={(isChecked) => props.onChange(props.type, isChecked)}
        ></AppSwitch>
      </div>
    </Flex>
  );
};

export default StaffingPreferenceSwitch;
